<template>
  <div v-if="propCursos.length > 0">
    <h1 style="font-size: xx-large; line-height: 35px; font-weight: bold;" :style="{ color: $ajustes.colorTexto2 }">
      NUESTROS CURSOS</h1>
    <h1 style="font-size:large; line-height: 35px; font-weight: normal;" :style="{ color: $ajustes.colorTexto2 }">
      Formarte es prepararte</h1>
    <v-row class="pt-2 center">
      <v-col class="ma-0 pa-2" v-for="curso in cursosDestacados" :key="curso.id" lg="3" md="4" sm="6" cols="12">
        <v-container class="pa-1" style="align-items: center;align-items: center;">
          <curso :propCurso="curso" @propAccion="activarFormulario"/>
        </v-container>
      </v-col>
    </v-row>
    <div style="width: 100%;" class="center mt-7 mb-5">
      <v-btn class="pa-6" :color="$ajustes.colorTexto2" :style="{ color: $ajustes.colorTexto1 }"
        @click="$router.push({ name: 'Cursos' })">
        <h1>VER TODOS LOS CURSOS</h1>
      </v-btn>
    </div>
    <v-dialog v-model="formularioDialogo" width="400px">
      <formulario :propId="infoFormulario.id" :propIndicacion="infoFormulario.indicacion" :propAsunto="infoFormulario.asunto"
        @propCerrarFormulario="formularioDialogo = false"  />
    </v-dialog>
  </div>
</template>
<script>
import curso from "@/components/template/curso";
import formulario from "@/components/template/formulario";

export default {
  components: {
    curso,
    formulario
  },
  props: {
    propCursos: { type: Array },
  },
  data() {
    return {
      formularioDialogo: false,
      infoFormulario: {id:"", asunto:"", indicacion:""}
    };
  },
  mounted() {
  },

  created() { },
  computed: {
    cursosDestacados() {
      return this.propCursos.filter(curso => curso.destacado & curso.habilitado);
    }
  },
  methods: {
        activarFormulario(id, titulo){
      this.infoFormulario.id=id
      this.infoFormulario.indicacion="¿Estas interesado en participar en el curso o taller de: "+ titulo+"?"
      this.infoFormulario.asunto="Interesado en "+ titulo
      this.formularioDialogo= true
    },
    continuar() { },
    close() { },
  },
};
</script>
<style scoped>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
